import { ImportState } from "./types";

export const defaultState = (): ImportState => {
  return {
    editing: null,
    makingApiRequest: false,
    lastUpdate: new Date(),
    imports: [],
    links: {}
  };
};

export const state = defaultState();
